import React, { Component } from "react";
import {connect} from 'react-redux';
import { languageService } from "../Services/LanguageService.js";
import GlossaryUploadForm from "../Components/Customer/GlossaryUploadForm";
import { customerService } from "../Services/CustomerService.js";


class GlosaryFormContainer extends Component {
	constructor(props){
		super(props);
		this.state = {
			glossary: null,
			uploading: 0,
			glossaryFile: ''
		};
		this.saveGlossary = this.saveGlossary.bind(this);
	}
	
	componentDidMount() {
		if(this.props.glossaryId>0){
			customerService.getGlossary(this.props.glossaryId)
				.then(response => this.setState({glossary: response.data}))
		}else{
			languageService.getLanguagePair(this.props.languagePairId)
				.then(response => this.setState({glossary: {"id": 0,
															"description": "",
															"languagePair": response.data,
															"customer": this.props.customerId
															}
									}))
				.catch(err => {/*console.log(err);*/});
		}
	}
	
	saveGlossary(glossary, description){
		let glosaryDto = this.state.glossary;
		glosaryDto.description = description;
		
		if(this.props.glossaryId>0){
			if(glossary){
				customerService.uploadGlossary(this.props.glossaryId, glossary)
					.then(response => customerService.updateGlossary(this.props.glossaryId, glosaryDto))
					.then(() => {return this.props.history.push('/customerForm/'+this.props.customerId);})
					.catch(err => {/*console.log(err);*/});
			}else{
				customerService.updateGlossary(this.props.glossaryId, glosaryDto)
					.then(() => {return this.props.history.push('/customerForm/'+this.props.customerId);})
					.catch(err => {/*console.log(err);*/});
			}
		}else{
			customerService.createGlossary(glosaryDto)
					.then(response => customerService.uploadGlossary(response.data.id, glossary))
					.then(() => {return this.props.history.push('/customerForm/'+this.props.customerId);})
					.catch(err => {/*console.log(err);*/});
		}
	}
	
	render() {
		return (<div className="content">
					<GlossaryUploadForm	
						glossary={this.state.glossary}
						uploadGlossary={this.saveGlossary}/>
				</div>);
	}
}

//<PrivateRoute path="/glossaryForm/:idCust/:idLang/:idCurentGlossary" component={ GlosaryFormContainer }  isLoged={this.props.isLoggedIn}/>
function mapStateToProps(state, ownProps) {  
//	return {glossary: state.glossary.find(g => {if(g.id == ownProps.match.params.idCustomer){ return true;}}), user: state.user,
//			languagePairId: ownProps.match.params.idLangPair}
	return {glossaryId: parseInt(ownProps.match.params.idCurentGlossary),
			languagePairId: parseInt(ownProps.match.params.idLang),
			customerId: parseInt(ownProps.match.params.idCust),
			user: state.user}
}

export default connect(mapStateToProps)(GlosaryFormContainer);  